<template>
  <div :class="'form-state-item ' + cls">
    <div class="form-state-label">
      <router-link :to="{ path: path }">
        {{ model.domainName }}
      </router-link>
    </div>
    <!-- <div class="form-state-actions">
      <span>
        <Icon type="ios-bug" v-if="model.querys.new > 0" color="#ec0808"/>
        <Icon type="ios-bug" v-if="model.querys.answered > 0" color="#e99d37"/>
      </span>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'form-state',
  props: ['model'],
  computed: {
    cls: function () {
      var cls = 'default'
      switch (this.model.status) {
        case 0:
          cls = 'blank'
          break
        case 1:
          cls = 'pending'
          break
        case 2:
          cls = 'finish'
          break
        default:
          cls = 'blank'
          break
      }
      // if (this.model.querys.new > 0) {
      //   cls = 'error'
      // } else if (this.model.querys.answered > 0) {
      //   cls = 'warning'
      // }
      return cls
    },
    path: function () {
      return '/study/' + this.$route.params.id + '/domain/' + this.model.id
    }
  }
}
</script>

<style>
.form-state-item {
  padding: 10px 20px;
  margin: 5px 0;
  background-color: #edf2f1;
  border: 1px solid #e5e8e7;
  border-left: 8px solid #d1d1d1;
}
.form-state-item.pending {
  border-left: 8px solid #53b9df;
}
.form-state-item.skip {
  border-left: 8px solid #f7a529;
}
.form-state-item.finish {
  border-left: 8px solid #3ca641;
}
.form-state-item.error {
  border-left: 8px solid #fa0606;
}
.form-state-item.warning {
  border-left: 8px solid #f7a529;
}
.form-state-label {
  display: inline-block;
}
.form-state-actions {
  letter-spacing: 6px;
  float: right;
  right: 20px;
}
</style>
